import { memo } from "react"
import "../index.scss";
import CustomScroll from '@src/component/customScroll';
import {RefuseReason} from "@src/config/index"
import BottomIcon from "@src/component/bottomIcon";
import { goto } from "@src/route";
import Store from "@src/util/store";
import failIcon from "@src/assets/image/rzIndex/fail.png"

const StateSucc = (props: any) => {
  const {refuse_type} = props;

  const phone = Store.get('phone').value;

  return (
    <div className="page bottomFit rzStatus">
      <CustomScroll>
        <div className="reFail">
          <img src={failIcon} alt="" />
          <p>抱歉，{refuse_type && RefuseReason[refuse_type]||'您的身份证信息填写有误'},修改后请重新提交资格预审。</p>
        </div>
      </CustomScroll>
      <footer>
        <p>若有疑问，请联系：<span onClick={()=> {location.href = `tel:${phone as string}`}}>{phone}</span></p>
        <div onClick={()=>goto('/uploadId')} className="button-them upload-next">
          去修改资料
        </div>
        <BottomIcon/>
      </footer>
    </div>

  )
}

export default memo(StateSucc);